// extracted by mini-css-extract-plugin
module.exports = {"title":"GroupVisits_title__2k58K","grid":"GroupVisits_grid__prsmr"};